import type { MetaFunction } from 'react-router'
import { STATIC_PAGE_HEADERS } from "~/lib/cache.server"
import { Link } from 'react-router'
import { Navbar } from '~/components/navbar'
import { Footer } from '~/components/footer'
import { MapPin, ArrowRight, Users } from 'lucide-react'

export function headers() { return STATIC_PAGE_HEADERS }

export const meta: MetaFunction = () => [
  { title: 'Annuaire artisans par région — Professionnels vérifiés | AfficheServices' },
  { name: 'description', content: 'Trouvez des artisans vérifiés dans votre région : Île-de-France, PACA, Occitanie et toute la France. Devis gratuits.' },
  { tagName: 'link', rel: 'canonical', href: 'https://www.afficheservices.fr/artisans' },
  { property: 'og:image', content: 'https://www.afficheservices.fr/api/og?title=Annuaire+artisans&subtitle=13+regions' },
]

const REGIONS = [
  { slug: 'ile-de-france', name: 'Île-de-France', cities: 'Paris, Versailles, Boulogne...' },
  { slug: 'auvergne-rhone-alpes', name: 'Auvergne-Rhône-Alpes', cities: 'Lyon, Grenoble, Annecy...' },
  { slug: 'provence-alpes-cote-d-azur', name: 'PACA', cities: 'Marseille, Nice, Toulon...' },
  { slug: 'nouvelle-aquitaine', name: 'Nouvelle-Aquitaine', cities: 'Bordeaux, La Rochelle, Pau...' },
  { slug: 'occitanie', name: 'Occitanie', cities: 'Toulouse, Montpellier, Nîmes...' },
  { slug: 'hauts-de-france', name: 'Hauts-de-France', cities: 'Lille, Amiens, Dunkerque...' },
  { slug: 'grand-est', name: 'Grand Est', cities: 'Strasbourg, Metz, Nancy...' },
  { slug: 'pays-de-la-loire', name: 'Pays de la Loire', cities: 'Nantes, Angers, Le Mans...' },
  { slug: 'bretagne', name: 'Bretagne', cities: 'Rennes, Brest, Vannes...' },
  { slug: 'normandie', name: 'Normandie', cities: 'Rouen, Le Havre, Caen...' },
  { slug: 'bourgogne-franche-comte', name: 'Bourgogne-Franche-Comté', cities: 'Dijon, Besançon...' },
  { slug: 'centre-val-de-loire', name: 'Centre-Val de Loire', cities: 'Tours, Orléans, Blois...' },
  { slug: 'corse', name: 'Corse', cities: 'Ajaccio, Bastia...' },
]

export default function ArtisansIndex() {
  return (
    <div className="min-h-screen bg-surface-secondary">
      <Navbar />
      <div className="mx-auto max-w-4xl px-4 py-12 lg:px-6">
        <div className="text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
            <Users className="h-7 w-7 text-primary" />
          </div>
          <h1 className="mt-4 text-3xl font-bold text-slate-900">Annuaire artisans par région</h1>
          <p className="mt-2 text-sm text-slate-500">Trouvez des professionnels vérifiés dans toute la France</p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {REGIONS.map((r) => (
            <Link key={r.slug} to={`/artisans/${r.slug}`}
              className="card-hover group flex items-center gap-4 rounded-2xl border border-border bg-white p-5 shadow-xs">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10">
                <MapPin className="h-5 w-5 text-primary" />
              </div>
              <div className="min-w-0 flex-1">
                <h2 className="text-base font-semibold text-slate-900 group-hover:text-primary">{r.name}</h2>
                <p className="text-xs text-slate-400">{r.cities}</p>
              </div>
              <ArrowRight className="h-4 w-4 shrink-0 text-slate-300 group-hover:text-primary" />
            </Link>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-slate-900 p-8 text-center">
          <h2 className="text-xl font-bold text-white">Besoin d'un artisan maintenant ?</h2>
          <p className="mt-2 text-sm text-slate-400">3 devis gratuits d'artisans vérifiés sous 48h</p>
          <Link to="/demande-devis/1" className="mt-4 inline-flex items-center gap-2 rounded-xl bg-primary px-8 py-3 text-sm font-semibold text-white shadow-md hover:bg-primary-hover btn-press">
            Demander un devis gratuit <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  )
}
